module.exports = {
      id: "twitter-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#twitter",
      toString: function () {
        return this.url;
      }
    }